MainCtrl.$inject = ['$rootScope','PortalApi', '$scope', '$timeout', 'Authentication', '$state', 'Localization','$interval','$http', '$document', '$window', 'Analytics', 'configs'];
function MainCtrl($rootScope, PortalApi, $scope, $timeout, Authentication, $state, Localization, $interval, $http, $document, $window, Analytics, configs) {
	var focusReturnTarget = null;
	try {
		focusReturnTarget = $window.sessionStorage.getItem('focusReturn');
	} catch (e) {}

	$timeout(function () {
		if (focusReturnTarget) {
			var focusElement = document.getElementById(focusReturnTarget) || document.querySelector('[data-focus-id=\"' + focusReturnTarget + '\"]');
			if (focusElement && typeof focusElement.focus === 'function') {
				focusElement.focus();
			}
			try {
				$window.sessionStorage.removeItem('focusReturn');
			} catch (e) {}
		}
	}, 0);

	$scope.isUser = Authentication.isLogged;
	$scope.Auth = Authentication;
	$scope.$state = $state;
	$rootScope.info = '1';
	$scope.name = 'TEST NAME';
	$scope.banner = 1;
	$scope.actMobSecTab = '';
	$scope.show = true;
    $scope.timeOut = false;
    $scope.configs = configs;
	$scope.mobileDropdown = {
		open: false,
		screenParams: {},
		operators : {}
	};

	$scope.language = Localization.active;

	$scope.$on('changeLang',function (event,data) {
		$scope.language = data.lang;
	});
	//for check mobile code for mobile devices
	$scope.$on('mobileDropdown',function (event, operators, screenParams) {
		$scope.mobileDropdown = {
			open: true,
			screenParams: screenParams,
			operators : operators
		};
	});

	// put scroll to top in start
	$scope.scrollTop = function () {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
	}

	$scope.showBlock = function(arg){ 	// change open tab
		$scope.info = arg;
	};

	$scope.swipe = function (arg) {
		$scope.next = arg.strNext;
		$scope.prev = arg.strPrev; // for swipe
	};

	$scope.setActMobSecTab = function (tabName) {
		$scope.actMobSecTab = tabName || 'bank';
	};

	$scope.toService = function(serviceId) {
		var data = {
			serviceId: serviceId,
			fields: [],
			amount: 0,
			autoCheck: false,
			url: serviceId
		};

		$scope.preLoader = true;
		$state.go('pages.payment', data);
	};

	/*history*/
		/*send sms code*/
			$scope.sendSMS = function(form) {
                $scope.preLoader = true;

                $timeout(function () {
                    $scope.timeOut = true;
                }, 2*60000);

                var data   = angular.copy($scope.billForm);
                $scope.smsPhone = data.phone = '380' + data.phone;

				PortalApi.historySmsSend(data.phone).then(function(result) {
                    if (result.status == 'ok') {
                        $scope.smsField = true;

                        Localization.notifyTemplate('success', 'MAIN.BILLS.SMS_SUCCESS', 5, true);

                        $scope.preLoader = false;
                    }
				}, function(res) {
                    if (res) {

                        Localization.notifyTemplate('error', 'ERRORS.UNKNOWN_ERROR', 5, true);

                        $scope.preLoader = false;
                    }
                });
			};
		/*end send sms code*/
		/*check sms code*/
    		$scope.verifySmsCode = function(form) {
                var data   = angular.copy($scope.smsConfirmForm);
				data.code  = form.code;
				data.phone = $scope.smsPhone;
				PortalApi.historySmsCheck(data).then(
                    function(result) {
                        if (result.status == 'ok') {
                            $state.go('pages.history', {
                                billsHistory: true
                            });
                        }
					}, function(res) {
                        if (res) {
							Localization.notifyTemplate('error', 'ERRORS.UNKNOWN_ERROR', 5, true);
                        }
                    });
    		};
		/*end check sms code*/
	/*end history*/

    $scope.setTab = function (int) {
		var to;
		if(!($state.current.name !== 'pages.main') && int != 1 && int !=2 && int !=3 && int !=4){


			$state.go('pages.services').then(function () {
				if(int == 'serv-tree-item-1'){
				    to = document.getElementById(int);
				    $document.scrollToElementAnimated(to,10);
				    return;
				}
			})
		}
        $rootScope.info = int;
    };

	if($rootScope.useFrame && $state.current.data.iframe == false){
		document.body.classList.remove('bodyContainer');
		$state.go('pages.error404');

	}

    $rootScope.$watch('info',function () {
       $scope.info = $rootScope.info;
    });

	var Base = {
		currentOpenAnswer: 0,
		currentMenuItem: 0,
		device: 'web',
		modalShow: false,
		user: Authentication.getUser(),
		logined: Authentication.isLogged,
		logout: function () {
			Authentication.logout();
		}
	};

	$scope.setActMobSecTab();

	$scope.Base = Base;

	Analytics.pageView();
}

module.exports = MainCtrl;



/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/main/controllers/main.js
 ** module id = 270
 ** module chunks = 1
 **/